import { FC, ReactNode } from 'react'
import { HeaderCell as RsuiteHeaderCell } from 'rsuite-table'

type Props = {
  children?: ReactNode
  /** Forwarded to the underlying cell — lets a page style one column's header
   *  (e.g. centring a numeric column, which the global cell-content rule in
   *  `Table.scss` otherwise forces left). */
  className?: string
}

const HeaderCell: FC<Props> = ({ children, ...props }: Props) => {
  return <RsuiteHeaderCell {...props}>{children}</RsuiteHeaderCell>
}

HeaderCell.defaultProps = {
  children: null
}

export default HeaderCell
